import getPensionOptions from "./PensionOptions";

const splitOption = (opt) => {
  const [fullNameRaw, typeRaw] = String(opt ?? "").split(" - ");
  const fullName = (fullNameRaw ?? "").trim();
  const type = (typeRaw ?? "").trim();
  return { fullName, type };
};

// Only first name in the label
const makeShortLabel = (fullName, type) => {
  const first = (fullName || "").trim().split(/\s+/)[0] || "";
  return type ? `${first} - ${type}` : first;
};

const getTFCOptions = (state) => {
  const pensionOptions = getPensionOptions(state) ?? [];
  const drawdowns = state.drawdowns ?? [];

  // Exclude already-used combos (full name + type)
  const existingKeys = new Set(
    drawdowns.map(
      (d) =>
        `${(d.name ?? "").trim().toLowerCase()} - ${(d.type ?? "")
          .trim()
          .toLowerCase()}`
    )
  );

  const baseOptions = pensionOptions
    .map((opt) => {
      const { fullName, type } = splitOption(opt);
      if (!fullName || !type) return null;

      const key = `${fullName.toLowerCase()} - ${type.toLowerCase()}`;
      if (existingKeys.has(key)) return null;

      return {
        value: `${fullName} - ${type}`, // keep full for value/lookup
        label: makeShortLabel(fullName, type), // show only first name
      };
    })
    .filter(Boolean);

  // De-duplicate identical short labels by suffixing (2), (3), ...
  const seen = new Map();
  return baseOptions.map((o) => {
    const count = (seen.get(o.label) ?? 0) + 1;
    seen.set(o.label, count);
    return count === 1 ? o : { ...o, label: `${o.label} (${count})` };
  });
};

export default getTFCOptions;
